import axios from "axios";
import { stage_url } from "../api-urls";

export async function updateUser(payload) {
    return await axios.put(
        `${stage_url}/api-business-v3/users/update/${payload.id}`,
        {},
        {
            params: payload, 
            headers: Headers.getHeaders(true),
        }
    );
}

export async function getUsers(mobile) {
    return await axios.get(
        `${stage_url}/api-business-v3/users`, 
        {
            params: { q: mobile },
            headers: Headers.getHeaders(true),
        }
    );
}
